import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }

import PageHeader from '@shared/components/pageHeader/PageHeader.vue';
import { computed } from 'vue';
import { TabItem } from '@shared/components/pageHeader/tabItem';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatformAdmin',
  setup(__props) {

const route = useRoute();
const isWorkspaceOpen = computed(() => String(route.name).startsWith('platform-admin-workspace-edit'));

const tabs = computed<TabItem[]>(() => {
  if (!isWorkspaceOpen.value) {
    return [];
  }
  return [
    { name: 'Apps & Features', route: 'platform-admin-workspace-edit' },
    { name: 'Users', route: 'platform-admin-workspace-edit-users' },
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      title: "Platform Admin",
      description: _unref(route).meta.description,
      tabs: tabs.value
    }, null, 8, ["description", "tabs"]),
    _createVNode(_component_router_view)
  ]))
}
}

})